var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header header-box screenWidth"},[_c('span',{staticClass:"floatL"},[_c('img',{staticClass:"logo",style:({'margin-left':_vm.flag? '20px': '0px'}),attrs:{"src":_vm.logoImg,"alt":""}})]),_c('span',{staticClass:"floatR",style:({'margin-right':_vm.flag? '20px': '0px'})},[_vm._v(_vm._s(_vm.time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }